import { useCallback, useEffect, useState } from "react";
import "./style.css";
import { fetchHedgeChart, fetchHedgeM2m, getAvgMedianCompApi, getFeedsenseReturnALL, getHedgeAnalyticsDetails, getMarketBeatDrawdown, getMultiplierList, getMutualFundDetailsALL, getMutualFundNames, getPortFolioAllocationDetails, getPortfolioCombinedWeightsData, getPortfolioMetric, getReturnCompData, getReturnPos, getSectorWeights } from "../../api/otherEndPoints/portfolioAnalytics";
import ListItemCard from "../../components/cards/ListItemCard";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { offset, TooltipFormatterContextObject } from "highcharts";
import moment from "moment";
import CriticalMatrixTable from "../../components/adviceStatus/CriticalMatrixTable";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import CustomDateRange from "../../components/customDateRange/CustomDateRange";
import jsPDF from "jspdf";
import ImageExport from "../../components/base64_images/feedsense_image";
import { Button } from 'primereact/button';
import { Button as BT, Modal, Spin, Table } from "antd";
import csvDownload from "json-to-csv-export";
import { getSymbolOptions } from "../../api/otherEndPoints/historicalPerformance";
import { Column } from 'primereact/column';
import * as XLSX from "xlsx";
import { Dropdown } from "primereact/dropdown"; //CHANGES
import { DataTable } from "primereact/datatable";
import { Select, Tooltip } from "antd";
import { displayAmount, generaliseExportCSV, numberWithCommas, portFolioCriticalMetricMapping, portFolioCriticalMetricMappingTableHeader } from "../../services/util/util";
import { MultiSelect } from "primereact/multiselect";
import { FaIndianRupeeSign } from 'react-icons/fa6';
import { FiInfo } from "react-icons/fi";
import { FaFileExcel } from "react-icons/fa6";
import GeneralisePreviewTable from "../../components/adviceStatus/GeneralisePreviewTable";


const Portfolio = () => {
  const [portfolioAllocationData, setPortfolioAllocationData] = useState<any>([])
  const [chartsData, setChartsData] = useState<any>([])
  const [startDate, setStartDate] = useState<any>('2019-04-09');
  const [endDate, setEndDate] = useState<any>(moment().format("YYYY-MM-DD"));
  const [sectorWeights, setSectorWeights] = useState<any>([])
  const [loadingCalc, setLoading] = useState<boolean>(false)

  const [startPortfolioDate, setStartPortfolioDate] = useState<any>('2019-04-09') // :any = '2019-05-05'
  const [endPortfolioDate, setEndPortfolioDate] = useState<any>(moment().format("YYYY-MM-DD")); //
  const [startReturnCalcDate, setStartReturnCalcDate] = useState<any>(moment()?.subtract(3, "year")?.format("YYYY-MM-DD")) // :any = '2019-05-05'
  const [endReturnCalcDate, setEndReturnCalcDate] = useState<any>(moment().format("YYYY-MM-DD")); //
  const [currdata, setCurrdata] = useState<any>([]);
  const [weightAllocationType, setWeightAllocationType] = useState<any>('equal_weights');
  const [returnComp, setReturnComp] = useState<any>([]);

  const [crmButtonClicked, setCRMButtonClicked] = useState<any>('365');
  const [avgMedianData, setAvgMedianData] = useState<any>([]);
  const [avgMedianDuration, setAvgMedianDuration] = useState<any>('365');
  const [returnPosi, setReturnPosi] = useState<any>([]);
  const [marketBeatddresponse, setMBDDResponse] = useState<any>([]);
  let todayDate: any = moment(new Date()).format("YYYY-MM-DD");

  // ---------- NEW CHANGES ----------- //
  const [drpValue, setDrpValue] = useState<any>([]);
  const [symbolsOptions, setSymbolsOptions] = useState<any>([]);
  const [stockQuantity, setStockQuantity] = useState<number>(0);
  const [investedAmount, setInvestedAmount] = useState<number>(0);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState<number>(0);
  const [totalInvestmentDetails, setTotalInvestmentDetails] = useState<any>([]);
  // const [selectedHedgeType, setSelectedHedgeType] = useState<string>('manual');
  const [selectedHedgeType, setSelectedHedgeType] = useState<string>('equal_allocation');
  const [hedgeMethodFirst, setHedgeMethodFirst] = useState<any>({});
  const [hedgeMethodSecond, setHedgeMethodSecond] = useState<any>({});
  const [portfolioDataFrame, setPortfolioDataFrame] = useState<any>([]);
  const [selectedAmount, setSelectedAmount] = useState<any>({ name: '1Cr', value: 10000000 });
  const [selectedAmountReturnCalc, setSelectedAmountReturnCalc] = useState<any>({ name: '1Cr', value: 10000000 });
  const [selectedMutualFund, setSelectedMutualFund] = useState<string[]>(['BEST 3 MF']);
  const [mutualFundNames, setMutualFundNames] = useState<any>([])
  const [mutualFundData, setMutualFundData] = useState<any>([])
  const [feedsensePortfolioData, setFeedsensePortfolioData] = useState<any>({})
  const [mutualFundReturnCalcDataArr, setMutualFundReturnCalcDataArr] = useState<any>([])
  const [usedAmount, setUsedAmount] = useState<any>({ 'usedAmount': 10000000, 'usedAmountReturn': 0 })
  const [investment, setInvestment] = useState<any>(10000000)
  const [hedgeSum, setHedgeSum] = useState<any>(0)
  const [showModal, setShowModal] = useState<boolean>(false);
  const [hedgeReturnChart, setHedgeReturnChart] = useState<any>([]);
  const [drawdownChart,setDrawdownChart] = useState<any>([])
  const [drawdownOrReturn, setDrawdownOrReturn] = useState<any>('Return');

  const [manualInputReturnCalc, setManualInputReturnCalc] = useState<string>('');


  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedPreviewTableData, setSelectedPreviewTableData] = useState<any[]>([]);
  const [selectedPreviewTableColumns, setSelectedPreviewTableColumns] = useState<any[]>([]);
  const [selectedPreviewTableColumnMapping, setSelectedPreviewTableColumnMapping] = useState<any>({});
  const [selectedFileName, setSelectedFileName] = useState<string>("");


  const memorizedExportCSV = useCallback(generaliseExportCSV,[isModalOpen,selectedPreviewTableData]);

  const debounceDelay = 500; // Adjust debounce time in milliseconds





  const [returnCompDataShow, setReturnCompDataShow] = useState<boolean>(false)
  const [returnCompDataExcel, setReturnDataExcel] = useState<any>([])
  const [returnCompDataDisplay, setReturnCompDataDisplay] = useState<any>([])
  let dataArr: any = []
  let labelsArr: any = []
  let colorsArr: any = []
  const theme: any = useSelector((state: any) => {
    return state.theme.isTheme;
  })
  let name: any = '';


  returnComp.map((data: any) => {
    dataArr.push(Number(data?.return_value)?.toFixed(2))
    labelsArr.push(data?.symbol)

    if (data?.symbol === 'NIFTY') {
      colorsArr.push('red')
    }
    else if (data?.symbol === 'PORTFOLIO') {
      colorsArr.push('green')
    }
    else if (data?.symbol === 'EQUAL WEIGHT') {
      colorsArr.push('blue')
    }
  })

  let axis_lable_color: any
  let border_color: any

  if (theme == 'dark' || theme == 'b/w') {
    axis_lable_color = '#F5F5DC'
    border_color = '#262626'
  }
  else if (theme == 'light') {
    axis_lable_color = '#000'
    border_color = '#a2cdf4'

  }
  if (theme == 'b/w') {
    axis_lable_color = '#F5F5DC'
    border_color = '#ffffff30'
  }

  // new changes
  const setDropdownOptions = async () => {
    let response = await getSymbolOptions('equityMultiday')
    if (response?.length >= 0) {
      setSymbolsOptions(response);
      setDrpValue(response?.[0])
    }
    else {
      setSymbolsOptions([])
    }
  }

  const setReturnMutualFundNames = async () => {
    let response = await getMutualFundNames()
    if (response?.length >= 0) {
      setMutualFundNames(response?.map((item: any) => { return item?.s_symbol }));
    }
  }

  const displayMutualFund = mutualFundNames?.map((val: any) => {
    return { name: val, value: val }
  })

  const getHedgereturnChart = async()=>{
    let res:any = await fetchHedgeChart()
    if (res?.length >= 0){
      setHedgeReturnChart(res)
    }
  }


  useEffect(() => {
    if(returnCompDataShow == true){
      formattingReturnCompData()

    }

  }, [returnCompDataShow])





  useEffect(() => {
    getPFAllocationDetails()
    getAllWeightsData()
    getSectoeWeightsFunc()
    getPosi()
    getMarketBeatandDrawdownresponse()
    setDropdownOptions() //NEW CHANGE
    setReturnMutualFundNames();
    handleReturnCalcSubmit();
    getHedgereturnChart();
    maxDrawdown();
  }, [])

  useEffect(() => {
    getReturnCompDataResponse()
  }, [crmButtonClicked])

  useEffect(() => {
    getAvgMedianCompData()
  }, [avgMedianDuration])

  const getPosi = async () => {
    let response: any = await getReturnPos()
    setReturnPosi(response)
  }

  useEffect(() => {
    getPortfolioMetricData(startPortfolioDate, endPortfolioDate)
  }, [startPortfolioDate, endPortfolioDate])

  const getPortfolioMetricData = async (startPortfolioDate: any, endPortfolioDate: any) => {
    let response: any = await getPortfolioMetric(startPortfolioDate, endPortfolioDate)
    setCurrdata(response)
  }

  const getAvgMedianCompData = async () => {
    let response: any = await getAvgMedianCompApi(avgMedianDuration)

    setAvgMedianData(response)
  }

  const getAllWeightsData = async () => {
    let response: any = await getPortfolioCombinedWeightsData(['N50_all', 'portfolio'], startDate, endDate)
    let keys:any = Object.keys(response);
    // // // Assume all arrays are the same length (1858)
    let length:any = response['duration']?.length
  
    // // // Initialize the result array
    let combined:any = [];
    if (length > 0){
        for (let i = 0; i < length; i++) {
          let elementsArray:any = []
          for (let key of keys) {
            elementsArray.push(response[key][i])
          }
          combined.push(elementsArray);
        }
    }

    setChartsData(response)
  }

  const getPFAllocationDetails = async () => {
    let res: any = await getPortFolioAllocationDetails(todayDate);
    setPortfolioAllocationData(res)
  }

  const getMarketBeatandDrawdownresponse = async () => {
    let response: any = await getMarketBeatDrawdown()
    setMBDDResponse(response)

  }

  const getReturnCompDataResponse = async () => {
    let response: any = await getReturnCompData(crmButtonClicked)
    if (response?.length > 0) {
      setReturnComp(response)
    }
  }

  const getSectoeWeightsFunc = async () => {
    let response: any = await getSectorWeights(todayDate);

    setSectorWeights(response)
  }


  const formattingReturnCompData = () => {
      let data_:any= {...chartsData, ...drawdownChart}

      let keys:any = ['duration', 'marketReturnValues', 'portfolioAfterHedgeValues', 'mutualfundResponseValues', 'portfolioReturnValues',
                        'equalWeightReturn', 'equalAllocationAfterHedgeValues', 'drawdownReturnValuesPortfolio', 'drawdownReturnValuesNifty', 'drawdownReturnValuesEqual'];

      let headers:any = [ 'Duration',
                        'Nifty 50',
                        'FS Portfolio (Hedge)',
                        'Mutual Fund (Best 3)',
                        'FS Portfolio',
                        'Equal Weight',
                        'Equal Weight (Hedge)',
                        'FS Portfolio Drawdown',
                        'Nifty 50 Drawdown',
                        'Equal Weight Drawdown']


      // // // Assume all arrays are the same length (1858)
      let length:any = data_['duration']?.length

      let formattedDataToShow:any = []
    
      // // // Initialize the result array
      let dataForExcelDownload:any = [headers];

      if (length > 0){
          for (let i = 0; i < length; i++) {
            let elementsArray:any = []
            let row:any = {}

            for (let key of keys) {
              elementsArray.push(data_[key][i])
              row[key] = data_[key][i]
            }
            formattedDataToShow.push(row)
            dataForExcelDownload.push(elementsArray);
          }

          setReturnDataExcel(dataForExcelDownload)
          setReturnCompDataDisplay(formattedDataToShow)
      }
  }


  const optionsReturn = {
    title: {
      text: `Annual Return Comparison`
    },
    xAxis: {
      categories: chartsData?.duration,
      labels: {
        rotation: -90,
      },
      crosshair: {
        color: '#FF0000',
        width: 1,
        dashStyle: 'dash'
      },
      minPadding: 0.2, 
      maxPadding: 0.2
    },
    series: [
      {
        name: 'Nifty 50',
        data: chartsData?.marketReturnValues,
        color: '#568ccd'
      },
      {
        name: `FS Portfolio (Hedge)`,
        data: chartsData?.portfolioAfterHedgeValues,
        color: 'orange',
        visible: true
      },{
        name: `Mutual Fund (Best 3)`,
        data: chartsData?.mutualfundResponseValues,
        color: '#4fc967',
        visible: true
      },
      {
        name: `FS Portfolio`,
        data: chartsData?.portfolioReturnValues,
        color: '#c45177',
        visible: false
      },
      {
        name: `Equal Weight`,
        data: chartsData?.equalWeightReturn,
        color: '#218383',
        visible: false
      },
      {
        name: `Equal Weight (Hedge)`,
        data: chartsData?.equalAllocationAfterHedgeValues,
        color: '#7a5eab',
        visible: false
      }
    ],
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function (this: TooltipFormatterContextObject) {
        const points: any = this?.points || [];
        let tooltip: any = `<b>${this?.x}</b><br>`;
        if (points?.length > 0) {
          tooltip += points?.map((item: any) => {
            return `<span style="color:${item?.color}">\u25CF</span> ${item?.series.name}: <b>${(item?.y)?.toFixed(2)}%</b><br>`
          }).join('');
        }
        return tooltip;
      }
    },
    chart: {
      type: 'area',
      borderWidth: -1,
      spacingTop: 25
    },
    credits: { enabled: false },
    accessibility: {
      enabled: false
    },
    plotOptions: {
      series: {
        fillOpacity: 0.1,
        pointPlacement: 'between' 
      }
    },
    legend: {
      align: 'center', 
      verticalAlign: 'top',
      layout: 'horizontal'
    },
    yAxis: {
      gridLineWidth: 0,
      crosshair: {
        color: '#FF0000',
        width: 1,
        dashStyle: 'dash'
      }
    },
  };

  const drawdownReturn = {
    title: {
      text: `Annual Drawdown Comparison`
    },
    xAxis: {
      categories: drawdownChart?.duration,
      labels: {
        rotation: -90,
        steps: 1000,
      },
      crosshair: {
        color: '#FF0000', // Red cursor line color
        width: 1,
        dashStyle: 'dash' // Style of the crosshair line
      }
    },
    series: [
      {
        name: 'Nifty 50',
        data: drawdownChart?.drawdownReturnValuesNifty,
        color: '#568ccd'
      },
      {
        name: 'Equal Weight',
        data: drawdownChart?.drawdownReturnValuesEqual,
        color: '#4fc967'
      },
      {
        name: 'FS Portfolio',
        data: drawdownChart?.drawdownReturnValuesPortfolio,
        color: 'orange'
      },
    ],

    tooltip: {
      shared: true, // Shared tooltip for both series
      useHTML: true,
      formatter: function (this: TooltipFormatterContextObject) {
        const points: any = this?.points || [];
        let tooltip: any = `<b>${this?.x}</b><br>`;
        if (points?.length > 0) {
          tooltip += points?.map((item: any) => {
            return `<span style="color:${item?.color}">\u25CF</span> ${item?.series.name}: <b>${(item?.y)?.toFixed(2)}</b><br>`
          }).join('');
        }
        return tooltip;
      }
    },
    chart: {
      // height: 600,
      type: 'area',
      borderWidth: -1,
      spacingTop: 25
    },
    credits: { enabled: false },
    accessibility: {
      enabled: false
    },
    plotOptions: {
      series: {
        fillOpacity: 0.1,
        pointPlacement: 'between' 
      }
    },
    legend: {
      align: 'center', 
      verticalAlign: 'top',
      layout: 'horizontal'
    },
    yAxis: {
      gridLineWidth: 0,
      crosshair: {
        color: '#FF0000', 
        width: 1,
        dashStyle: 'dash'
      }
    },
  };

  const data1: any = {
    series: [{
      name: 'Market Return (%)',
      data: dataArr
    }],
    options: {
      title: {
      },
      chart: {
        type: 'bar',
        // height:'100px',
        animations: {
          enabled: false,
          easing: 'linear',
          speed: 1800,
          animateGradually: {
            enabled: true,
            delay: 50
          },
          dynamicAnimation: {
            enabled: true,
            speed: 100
          },
        },
        toolbar: {
          show: false,
          tools: {
            download: false
          }
        }
      },
      colors: [function ({ value, seriesIndex, w }: any) {
        if (value < 0) {
          return '#c72222'
        } else {
          return '#2fc457'
        }
      }],
      grid: {
        borderColor: '',
        row: {
          opacity: 0.5
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: '70%'
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '1.8socket.onrem',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold'
        },
      },
      xaxis: {
        tickAmount: 7,
        categories: labelsArr,
        labels: {
          show: true,
          rotate: -30,
          rotateAlways: true,
          style: {
            colors: axis_lable_color,
            fontSize: '0.7rem',
          }
        }
      },
      yaxis: {
        tickAmount: 10,
        min: Math.min(...dataArr, 0) * 1, // Ensure space for negative values
        max: Math.max(...dataArr, 0) * 1, // Ensure positive values scale well
        forceNiceScale: true,
        labels: {
          show: false,
          style: {
            colors: axis_lable_color
          }
        },
        title: {
          text: name,
          style: {
            color: axis_lable_color
          }
        },

      }, returnPosi
    },
  };

  const positiveSeries = hedgeReturnChart?.map((item: any) =>
    item.n_est_pl >= 0 ? item.n_est_pl : null
  );

  const negativeSeries = hedgeReturnChart?.map((item: any) =>
    item.n_est_pl < 0 ? item.n_est_pl : null
  );
  
  const data2: any = {
    series: [
      {
        name: "PL",
        data: positiveSeries,
        color: "#2fc457", // Green
      },
      {
        name: "PL",
        data: negativeSeries,
        color: "#c72222", // Red
      },
    ],
    options: {
      chart: {
        type: "line",
        animations: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false, 
        },
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      markers: {
        size: 4,
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: hedgeReturnChart?.map((item: any) => item?.n_strike_price),
        labels: {
          show: false, 
        },
        tooltip:{
          enabled:false,
        },
        axisBorder: {
          show: false, 
        },
        axisTicks: {
          show: false, 
        },
        tickAmount: undefined,
        title: {
          text: "Strike Price (PUT)", 
          offsetY:-60,
          style: {
            color: axis_lable_color,
            fontSize: "0.8rem",
            fontWeight: "600",
          },
        },
      },
      yaxis: {
        forceNiceScale: true,
        labels: {
          show: false,
          style: {
            colors: axis_lable_color,
          },
        },
        title: {
          text: "Expected Gain", 
          style: {
            color: axis_lable_color,
            fontSize: "0.8rem",
            fontWeight: "600",
          },
        },
      },
      grid:{
        show:false,
      },
      legend:{
        show:false,
      },
      annotations: {
        yaxis: [
          {
            y: 0,
            borderColor: "#000",
            strokeDashArray: 0,
            label: {
              text: "Zero Line",
              style: {
                color: "#000",
                background: "#fff",
              },
            },
          },
        ],
      },
      tooltip: {
        enabled: true,
        // shared: false,
        custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
          const strikePrice = w.globals.categoryLabels[dataPointIndex]; // Get X-axis value
          const posPL = series[0][dataPointIndex]; // PL from positive series
          const negPL = series[1][dataPointIndex]; // PL from negative series
      
          // Get the correct PL value (ignore null)
          const plValue = posPL !== null ? posPL : negPL;
          const color = plValue >= 0 ? "#38a060" : "#c72222"; // Set color based on value
      
          // Return tooltip only if PL value exists
          if (plValue !== null) {
            return `
              <div style="
                background: white; 
                border: 1px solid ${color}; 
                padding: 8px; 
                box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
              ">
                <div style="font-size: 13px; font-weight: bold; color: black;">
                  Strike Price: ${strikePrice}
                </div>
                <div style="margin-top: 4px; font-size: 13px; font-weight: bold;">
                PL: <span style="color: ${color}; ">${plValue}</span>
              </div>
              </div>`;
          }
      
          return ""; // If PL is null, don't show anything
        },
      }
      
    },
  };


  const fullNamesMap: { [key: string]: string } = {
    "FS Portfolio + Hedge": "Feedsense Optimised Portfolio (With Hedge)",
    "FS Portfolio": "Feedsense Optimised Portfolio",
    "FS Equal": "Feedsense Equal Portfolio",
    "Avg 3MF": "Average Mutual Fund",
    "Nifty 50": "Nifty 50",
  };

  const calcMFReturnData: any = {
    series: [{
      name: 'Compared Return(%)',
      data: mutualFundReturnCalcDataArr
    }],
    options: {
      title: {
      },
      chart: {
        type: 'bar',
        // height:'100px',
        animations: {
          enabled: false,
          easing: 'linear',
          speed: 1800,
          animateGradually: {
            enabled: true,
            delay: 50
          },
          dynamicAnimation: {
            enabled: true,
            speed: 100
          },
        },
        toolbar: {
          show: false,
          tools: {
            download: false
          }
        }
      },
      colors: [function ({ value, seriesIndex, w }: any) {
        if (value < 0) {
          return '#c72222'
        } else {
          return '#2fc457'
        }
      }],
      grid: {
        borderColor: '',
        row: {
          opacity: 0.5
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: '50%', // Ensures bars are not too wide
        }
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '1.8socket.onrem',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold'
        },
      },
      xaxis: {
        tickAmount: 7,
        categories: Object.keys(fullNamesMap),
        offsetX:20,
        labels: {
          show: true,
          rotate: -30,
          rotateAlways: true,
          position: 'end',
          style: {
            colors: axis_lable_color,
            fontSize: '0.7rem',
          }
        }
      },
      tooltip: {
        enabled: true,
        x: {
          formatter: function (_value: number, { dataPointIndex }: any) {
            return fullNamesMap[Object.keys(fullNamesMap)[dataPointIndex]];
          }
        }
      },
      yaxis: {
        tickAmount: 10,
        min: Math.min(...mutualFundReturnCalcDataArr, 0) * 1, // Ensure space for negative values
        max: Math.max(...mutualFundReturnCalcDataArr, 0) * 1,
        forceNiceScale: true,
        labels: {
          show: false,
          style: {
            colors: axis_lable_color
          }
        },
        title: {
          text: name,
          style: {
            color: axis_lable_color
          }
        },

      }, returnPosi
    },
  };

  const tradesExports = (data: any, value: number) => {
    const tradeDataToConvert = {
      data: currdata,
      filename: `Portfolio Evaluation`,
      delimiter: ",",
      headers: [
        "Stock",
        "Rolling Duration",
        "Sharpe_ratio",
        "Beta",
        "Jensen_alpha",
        "Treynor_ratio",
        "Tracking_error",
        "Information_ratio",
        "Deflated_sharpe_ratio",
        "Co-efficient of Variation",
        "Modified_var",
        "Modified_sharpe_ratio",
        "Mar Ratio",
        "Sterling_ratio",
        "Semi_deviation",
        "Sortino_ratio",
        "Ulcer_index",
        "Calmer_ratio",
        "Omega_ratio",
        "Kappa_ratio"

      ],
    }
    csvDownload(tradeDataToConvert);

  }

  const exportPdfColumns = [
    { name: "Symbols", value: "s_symbol" },
    { name: "Sharpe Ratio", value: "n_sharpe_ratio" },
    { name: "Beta", value: "n_beta" },
    { name: "Jensen's Alpha", value: "n_jensen_alpha" },
    { name: "Treynor Ratio", value: "n_treynor_ratio" },
    { name: "Tracking Error", value: "n_tracking_error" },
    { name: "Information Ratio", value: "n_information_ratio" },
    { name: "Deflated Sharpe Ratio", value: "n_deflated_sharpe_ratio" },
    { name: "Co-efficient of Variation", value: "n_cov" },
    { name: "Modified Var", value: "n_modified_var" },
    { name: "Modified Sharpe Ratio", value: "n_modified_sharpe_ratio" },
    { name: "MAR Ratio", value: "n_mar" },
    { name: "Sterling Reserve", value: "n_sterling_ratio" },
    { name: "Semi Deviation", value: "n_semi_deviation" },
    { name: "Sortino Ratio", value: "n_sortino_ratio" },
    { name: "Ulcer Index", value: "n_ulcer_index" },
    { name: "Calmer Ratio", value: "n_calmer_ratio" },
    { name: "Omega Ratio", value: "n_omega_ratio" },
    { name: "Kappa Ratio", value: "n_kappa_ratio" },

  ]

  function addWaterMark(doc: any) {
    var totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setGState(new doc.GState({ opacity: 0.7 }));
      doc.setPage(i);
      doc.setFontSize(48)
      doc.setFont('Helvetica', 'bold')
      doc.setTextColor(230, 230, 230);
      doc.text('FeedSense AI', 160, 160, null, 45, 'center');
    }
    return doc;
  }

  const addFooters = (doc: any) => {
    const pageCount = doc.internal.getNumberOfPages()
    doc.setFont('helvetica', 'italic')
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.text('Page ' + String(i) + ' of ' + String(pageCount), 260, 200)
      if (i == pageCount) {
        doc.setFont('Helvetica', 'italic')
        doc.text('Disclaimer: We are using statistical and artificial models etc. which are never error-free. Please apply your own discretions while using this information.', 10, 200)
      }
    }
  }

  const exportCols = exportPdfColumns.map((exportPdfColumn) => ({ title: exportPdfColumn.name, dataKey: exportPdfColumn.value }));
  const exportPdf = () => {
    var doc = new jsPDF('l');
    var image = ImageExport()
    doc.addImage(image, 'PNG', 125, 10, 50, 15);
    doc.setFont('Lato-Regular', 'bold')
    doc.setFontSize(13)
    doc.text('Portfolio Evaluation Of Cash Models', 145, 35, { align: 'center' });
    (doc as any).autoTable(exportCols, currdata, {
      styles: {
        halign: 'left'
      },
      startY: 40,
      headStyles: { lineWidth: 0.5, fillColor: [224, 224, 224], textColor: [0, 0, 0] },
      theme: 'grid',
    }
    );
    doc = addWaterMark(doc)
    addFooters(doc)
    doc.save('FeedSense AI | Portfolio Evaluation.pdf');
  };

  // CHANGES
  useEffect(() => {
    setTotalInvestedAmount(stockQuantity * investedAmount);
  }, [stockQuantity, investedAmount])

  const handleAddToPortFolio = () => {
    let obj: any = {
      asset_name: drpValue['s_symbol'],
      quantity: stockQuantity,
      transaction: investedAmount,
      investment_amount: totalInvestedAmount,
    };
    if (stockQuantity > 0) {
      let isUpdated = false;
      const updatedDetails = totalInvestmentDetails.map((item: any) => {
        if (item['asset_name'] === obj['asset_name']) {
          isUpdated = true;
          return {
            ...item,
            quantity: (item['quantity'] + obj['quantity']),
            transaction: ((item['investment_amount'] + obj['investment_amount']) / (item['quantity'] + obj['quantity'])),
            investment_amount: item['investment_amount'] + obj['investment_amount'],
          };
        }
        return item;
      });

      if (!isUpdated) {
        setTotalInvestmentDetails((prev: any) => [...prev, obj]);
      } else {
        setTotalInvestmentDetails(updatedDetails);
      }
      setStockQuantity(0);
      setInvestedAmount(0);
      setTotalInvestedAmount(0);
    }
  };

  function resetData() {
    setHedgeMethodFirst([]);
    setHedgeMethodSecond([]);
    setPortfolioDataFrame([]);
  }

  const handleOptionChange = async (value: string) => {
    setSelectedHedgeType(value);
    if (value === 'nifty_fifty') {
      fetchHedgeSuggestion(value, { "investment_amount": selectedAmount['value'] });
    }
    else if (value === 'equal_allocation') {
      fetchHedgeSuggestion(value, { "investment_amount": selectedAmount['value'] });
    }
    else if (value === 'portfolio') {
      fetchHedgeSuggestion(value, { "investment_amount": selectedAmount['value'] });
    }
  }

  useEffect(() => {
    handleOptionChange(selectedHedgeType);
  }, [selectedAmount])


  // const fetchHedgeSuggestion = async (api_uri: string, details: { [key: string]: any }) => {
  //   try {
  //     resetData();
  //     await getHedgeAnalyticsDetails(api_uri, details)
  //       .then((respo: any) => {
  //         if (respo['Method 1'][0]['lots_required'] > 0){
  //           setHedgeMethodFirst(respo['Method 1']);
  //         }            
  //         else setHedgeMethodFirst([]);

  //         if (respo['Method 2'][0]['lots_required'] > 0) {
  //           setHedgeMethodSecond(respo['Method 2']);
  //         } 
  //         else setHedgeMethodSecond([]);

  //       })
  //       .catch((e: any) => {
  //         resetData();
  //       })
  //   } catch (e) {
  //     resetData();
  //     console.log(e);
  //   }
  // }

  const fetchHedgeSuggestion = async (api_uri: string, details: { [key: string]: any }) => {
    try {
      resetData();
      await getHedgeAnalyticsDetails(api_uri, details)
        .then((respo: any) => {
          if (respo['Method 1'][0]['lots_required'] > 0){

            let mainResponse1:any = respo['Method 1']?.length > 0 ? respo['Method 1']?.map((item:any) => {
              return {...item, "expiry_date" :  moment(item?.expiry_date).format("DD MMM YYYY")}
            }) : []
            setHedgeMethodFirst(mainResponse1);
          }            
          else setHedgeMethodFirst([]);

          if (respo['Method 2'][0]['lots_required'] > 0) {

            let mainResponse2:any = respo['Method 2']?.length > 0 ? respo['Method 2']?.map((item:any) => {
              return {...item, "expiry_date" :  moment(item?.expiry_date).format("DD MMM YYYY")}
            }) : []

            setHedgeMethodSecond(mainResponse2);
          }
          else setHedgeMethodSecond([]);

        })
        .catch((e: any) => {
          resetData();
        })
    } catch (e) {
      resetData();
      console.log(e);
    }
  }


  const changeValue = (value: any) => {
    if (value === '' || value === undefined || value === null) return '';
    else return Number(value)?.toFixed(2);
  };

  const handleReturnAmountChange = (value: number) => {
    const selectedObj = displayAmount.find((item: any) => item.value === value);
    setSelectedAmountReturnCalc(selectedObj || displayAmount[0]); // Fallback to first item
  };

  const handleReturnCalcSubmit = async () => {
    setLoading(true)
    let response = await getMutualFundDetailsALL(startReturnCalcDate, endReturnCalcDate, selectedAmountReturnCalc, selectedMutualFund);
    if (response) {
      // setLoading(false);
      setMutualFundData(response?.mutualFundData)
      setUsedAmount({ 'usedAmount': response?.averageNetValue, 'usedAmountReturn': response?.averageNetValueReturn })
      let feedsenseRes: any = await getFeedsenseReturnALL(startReturnCalcDate, endReturnCalcDate, selectedAmountReturnCalc)
      if (feedsenseRes) {

        console.log("feedsenseRes : ", feedsenseRes, feedsenseRes['nifty50return'])

        setInvestment(selectedAmountReturnCalc?.value)
        setFeedsensePortfolioData(feedsenseRes);
        const dbData = await fetchHedgeM2m(startReturnCalcDate, endReturnCalcDate); // Replace with actual DB fetch function
        if (dbData) {
          const sum = await hedgePl(dbData, startReturnCalcDate, endReturnCalcDate);
          console.log("sum hedge :", sum)
          setHedgeSum(sum)
          setLoading(false);
          setMutualFundReturnCalcDataArr([((((Number(feedsenseRes['feedsenseHedgeReturn']) + Number(sum)) / selectedAmountReturnCalc?.value) - 1) * 100)?.toFixed(2), feedsenseRes['feedsenseOptReturn'], feedsenseRes['feedsenseEqualReturn'], response['averageReturn'], feedsenseRes['niftyreturn']])
        }
      }
      
    }
  }

  const handleMutualFundChange = (e: any) => {
    if (e.value.length <= 5) {
      setSelectedMutualFund(e.value); // Allow selection only up to 3 items
    }
  };

  const handleCustomChange = (value: string) => {
    setManualInputReturnCalc(value); // Update the temporary input state
  };

  // Debounce effect to update selectedAmount after typing stops
  useEffect(() => {
    const handler = setTimeout(() => {
      const numericValue = parseFloat(manualInputReturnCalc.replace(/[^0-9]/g, '')); // Extract numbers
      if (!isNaN(numericValue)) {
        setSelectedAmountReturnCalc({ name: `${numericValue}`, value: numericValue });
      }
    }, debounceDelay);

    return () => clearTimeout(handler); // Cleanup on re-renders
  }, [manualInputReturnCalc]);

  useEffect(() => {
    if (selectedMutualFund?.length === 0) {
      setSelectedMutualFund(['ALL'])
    }
  }, [selectedMutualFund])




  async function MTMExtraction(a: any) {
    try {
      // console.log("mtm inside:", a)
      // let jsonString = a.j_m2m.trim(); // Remove leading/trailing spaces

      // Convert single quotes to double quotes and ensure valid JSON format
      // jsonString = jsonString.replace(/'/g, '"');

      // // Parse the corrected JSON string
      // const mtmDict: any = JSON.parse(jsonString);
      const mtmDict = a.j_m2m;

      const dates: any = Object.keys(mtmDict);
      const cummMtm: any = Object.values(mtmDict);

      let mtm = [0];
      for (let i = 1; i < cummMtm.length; i++) {
        mtm.push(cummMtm[i] - cummMtm[i - 1]);
      }

      const lot = a.n_lots;
      const plInRs = mtm.map(value => value * lot * 75);

      return dates.map((date: any, index: any) => ({
        DATE: date,
        "CUMM MTM": cummMtm[index],
        MTM: mtm[index],
        LOT: lot,
        "PL in Rs": plInRs[index]
      }));
    } catch (error) {
      console.error("Error parsing JSON:", error, "j_m2m Value:", a.j_m2m);
      return [];
    }
  }



  async function hedgePl(data: any, startDate: any, endDate: any) {
    const extractedData = (await Promise.all(data.map(MTMExtraction))).flat();
    return extractedData
      .filter((row: any) => row.DATE >= startDate && row.DATE <= endDate)
      .reduce((sum: any, row: any) => sum + row["PL in Rs"], 0);
  }



  const downloadMutualExcel = (data: any) => {
    if (!data || data.length === 0) {
      console.error("No data available to export.");
      return;
    }
    // Define column headers
    const headers = [["Symbol", "Return(%)"]];

    // Summary rows (Added immediately after headers)
    const summaryRows = [
      ["Feedsense Optimised Hedge Portfolio", mutualFundReturnCalcDataArr[0]],
      ["Feedsense Optimised Portfolio", mutualFundReturnCalcDataArr[1]],
      ["Feedsense Equal Portfolio", mutualFundReturnCalcDataArr[2]],
    ];

    // Convert mutual fund data to an array of arrays
    const formattedData = data.map((item: any) => [item.s_symbol, item.product_multiplier]);

    // Combine headers, summary rows, and mutual fund data
    const finalData = [...headers, ...summaryRows, ...formattedData];

    console.log("finalData :",finalData)

    // Create a new worksheet using aoa_to_sheet (Array of Arrays)
    const worksheet = XLSX.utils.aoa_to_sheet(finalData);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the file
    XLSX.writeFile(workbook, "Comparison with Mutual Fund.xlsx");
  };

  const columnsMF = [
    {
      title: 'Symbols',
      dataIndex: 's_symbol',
      key: 's_symbol',
      width: "60%", // Adjust width for spacing
      // sorter: (a: any, b: any) => a['product_multiplier']?.toString()?.localeCompare(b['product_multiplier']),
      // align: "center" as "center",
    },
    {
      title: 'Return(%)',
      dataIndex: 'product_multiplier',
      key: 'product_multiplier',
      width: "40%", // Adjust width for spacing
      align:"center" as "center",
      sorter: (a: any, b: any) => a['product_multiplier']-b['product_multiplier'],
      render: (val: any) => <b style={{color:val>=0?'green':'red'}}>{val}</b>,
    },
 ];

 const additionalRows = [
  {
    key: "opt-hedge",
    s_symbol: "Feedsense Optimised Portfolio (With Hedge)",
    product_multiplier: (
      (((Number(feedsensePortfolioData?.feedsenseHedgeReturn) + Number(hedgeSum)) /
        selectedAmountReturnCalc?.value -
        1) *
        100
      )?.toFixed(2)
    ),
  },
  {
    key: "opt",
    s_symbol: "Feedsense Optimised Portfolio",
    product_multiplier: feedsensePortfolioData?.feedsenseOptReturn,
  },
  {
    key: "equal",
    s_symbol: "Feedsense Equal Portfolio",
    product_multiplier: feedsensePortfolioData?.feedsenseEqualReturn,
  },
];

// Combine additional rows with actual data (without modifying the original state)
  const tableData = [...additionalRows, ...mutualFundData];

const  maxDrawdown = async ()=> {
  let multiplierList:any = await getMultiplierList(startPortfolioDate, endPortfolioDate);
  if(multiplierList) setDrawdownChart(multiplierList)
}

const downloadReturnCompAndDrawdownData = (data:any) => {

    // Create a new worksheet using aoa_to_sheet (Array of Arrays)
    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the file
    XLSX.writeFile(workbook, "Comparison with Mutual Fund.xlsx");
}

  const columnreturnDrawdown:any = [
    {
        title: 'Date Range',
        dataIndex: 'duration',
        key: 'duration',
        width: "70%", // Adjust width for spacing
        sorter: (a: any, b: any) => {
          const dateA:any = new Date(a.duration.split(' - ')[0].trim());
          const dateB:any = new Date(b.duration.split(' - ')[0].trim());
          return dateA.getTime() - dateB.getTime(); // Or just: dateA - dateB
        },
    },
    {
        title: 'Nifty 50',
        dataIndex: 'marketReturnValues',
        key: 'marketReturnValues',
        width: "40%", // Adjust width for spacing
        align: "center" as "center",
        sorter: (a: any, b: any) => a['marketReturnValues'] - b['marketReturnValues'],
        render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
        title: 'FS Portfolio (Hedge)',
        dataIndex: 'portfolioAfterHedgeValues',
        key: 'portfolioAfterHedgeValues',
        width: "40%", // Adjust width for spacing
        align: "center" as "center",
        sorter: (a: any, b: any) => a['portfolioAfterHedgeValues'] - b['portfolioAfterHedgeValues'],
        render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
        title: 'Mutual Fund (Best 3)',
        dataIndex: 'mutualfundResponseValues',
        key: 'mutualfundResponseValues',
        width: "40%", // Adjust width for spacing
        align: "center" as "center",
        sorter: (a: any, b: any) => a['mutualfundResponseValues'] - b['mutualfundResponseValues'],
        render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,

    },
    {
        title: 'FS Portfolio',
        dataIndex: 'portfolioReturnValues',
        key: 'portfolioReturnValues',
        width: "40%", // Adjust width for spacing
        align: "center" as "center",
        sorter: (a: any, b: any) => a['portfolioReturnValues'] - b['portfolioReturnValues'],
        render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
      title: 'Equal Weight',
      dataIndex: 'equalWeightReturn',
      key: 'equalWeightReturn',
      width: "40%", // Adjust width for spacing
      align: "center" as "center",
      sorter: (a: any, b: any) => a['equalWeightReturn'] - b['equalWeightReturn'],
      render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
      title: 'Equal Weight (Hedge)',
      dataIndex: 'equalAllocationAfterHedgeValues',
      key: 'equalAllocationAfterHedgeValues',
      width: "40%", // Adjust width for spacing
      align: "center" as "center",
      sorter: (a: any, b: any) => a['equalAllocationAfterHedgeValues'] - b['equalAllocationAfterHedgeValues'],
      render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
      title: 'FS Portfolio Drawdown',
      dataIndex: 'drawdownReturnValuesPortfolio',
      key: 'drawdownReturnValuesPortfolio',
      width: "40%", // Adjust width for spacing
      align: "center" as "center",
      sorter: (a: any, b: any) => a['drawdownReturnValuesPortfolio'] - b['drawdownReturnValuesPortfolio'],
      render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
      title: 'Nifty 50 Drawdown',
      dataIndex: 'drawdownReturnValuesNifty',
      key: 'drawdownReturnValuesNifty',
      width: "40%", // Adjust width for spacing
      align: "center" as "center",
      sorter: (a: any, b: any) => a['drawdownReturnValuesNifty'] - b['drawdownReturnValuesNifty'],
      render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    },
    {
      title: 'Equal Weight Drawdown',
      dataIndex: 'drawdownReturnValuesEqual',
      key: 'drawdownReturnValuesEqual',
      width: "40%", // Adjust width for spacing
      align: "center" as "center",
      sorter: (a: any, b: any) => a['drawdownReturnValuesEqual'] - b['drawdownReturnValuesEqual'],
      render: (val: any) => <span >{Number(val)?.toFixed(2)}</span>,
    }
  ];


  return (
    <>
      <div>
      <GeneralisePreviewTable
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          columnHeader={selectedPreviewTableColumns}
          tableData={selectedPreviewTableData}
          onDownload={()=>{memorizedExportCSV(selectedPreviewTableData, selectedPreviewTableColumnMapping, selectedFileName)}}
        />
        <span className='portfolio_headerName_title'>Portfolio Analytics</span>
        <div className="portfolio_list_card">
          <ListItemCard portfolioAllocationData={portfolioAllocationData} setPortfolioAllocationData={setPortfolioAllocationData} weightAllocationType={weightAllocationType}
            setWeightAllocationType={setWeightAllocationType} sectorWeights={sectorWeights} selectedAmount={selectedAmount} setSelectedAmount={setSelectedAmount} />
        </div>
        <div className="portfolio">
          <div className="portfolio_return_charts">
            <div className="drawdownAndReturn">
            <span style={{ display: 'flex', justifyContent: 'end', color: '#2ca32c', fontSize: '1.3rem', cursor: 'pointer',padding: '5px 8px' }}><FaFileExcel onClick={()=>setReturnCompDataShow(true)}/></span>
              <Select key={drawdownOrReturn}  value={drawdownOrReturn} onChange={(val:any)=>{setDrawdownOrReturn(val)}}>
                <Select.Option key="Return" value="Return">Return</Select.Option>
                <Select.Option key="Drawdown" value="Drawdown">Drawdown</Select.Option>
              </Select>
            </div>
            <HighchartsReact highcharts={Highcharts} key={drawdownOrReturn} oneToOne={true} options={drawdownOrReturn=='Return'?optionsReturn:drawdownReturn} />
          </div>
          <div className="sectoral_weights_main">
            {/* <span className="sectoralWeight_text">CRM<FiInfo className='ModelWeightsInfo' /></span> */}
            <div>
              <span className="sectoralWeight_text">Market Return (%)</span>
              <ReactApexChart id="chartsPortfolio" options={data1.options} series={data1.series} type="bar" height="90%" />
            </div>
            <div style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}>
              <button className="portfolio_yr_btn" onClick={() => { setCRMButtonClicked('90') }} id={crmButtonClicked === '90' ? 'crmButtonColour' : ''}>90</button>
              <button className="portfolio_yr_btn" onClick={() => { setCRMButtonClicked('180') }} id={crmButtonClicked === '180' ? 'crmButtonColour' : ''}>180</button>
              <button className="portfolio_yr_btn" onClick={() => { setCRMButtonClicked('365') }} id={crmButtonClicked === '365' ? 'crmButtonColour' : ''}>365</button>
              <button className="portfolio_yr_btn" onClick={() => { setCRMButtonClicked('All') }} id={crmButtonClicked === 'All' ? 'crmButtonColour' : ''}><Tooltip title='Since Feedsense Inception' placement='top'>SI</Tooltip></button>
            </div>
          </div>
        </div>
        {/* ------------- HEDGE CHANGES STARTS HERE ------------- */}
        <div className="hedgeMainDiv">
          <span className="tableHeaderPortfolio" style={{ margin: '0 0 0.5rem 0.5rem' }}>Hedge Analytics</span>
          <div className="hedgeDataComponentDiv">

            {selectedHedgeType === 'manual' && <div className="stockAndInvestmentSection">
              <div className="stockMainSection">
                <div className="stockSection">
                  <div className="input-container">
                    <h6>Select stock</h6>
                    <Dropdown style={{ width: "98%", float: "left", height: "3rem" }} value={drpValue} onChange={(e: any) => { setDrpValue(e.target.value) }} options={symbolsOptions} optionLabel="s_symbol" placeholder="Select Symbol" checkmark={true} highlightOnSelect={false} />
                  </div>
                  <div className="input-container">
                    <h6>Buy quantity</h6>
                    <input type="number" id="numberInput" value={stockQuantity} onChange={(e: any) => setStockQuantity(Number(e.target.value))} />
                  </div>
                  <div className="input-container">
                    <h6>Buy Price</h6>
                    <input type="number" value={investedAmount} onChange={(e: any) => setInvestedAmount(Number(e.target.value))} />
                  </div>
                </div>
                <div className="totalAmountSection">
                  <div id="amountDiv"><h6>Total investment amount (Rs.): &nbsp; {totalInvestedAmount}</h6></div>
                  <button type="button" id="addtoportfoliobtn" onClick={() => handleAddToPortFolio()}>Add to portfolio</button>
                </div>
              </div>

              <div className="investmentSection">
                <DataTable className="hedgeTable" value={totalInvestmentDetails} scrollable resizableColumns stripedRows sortMode="multiple" scrollHeight="200px">
                  <Column field="asset_name" header="Asset" style={{ minWidth: '100px' }} sortable></Column>
                  <Column field="quantity" header="Quantity" style={{ minWidth: '150px' }}></Column>
                  <Column field="transaction" header="Transaction" style={{ minWidth: '150px' }}> </Column>
                  <Column field="investment_amount" header="Investment" style={{ minWidth: '150px' }}> </Column>
                </DataTable>
                {totalInvestmentDetails.length > 0 &&
                  <div className="hedgeSuggestionBtnDiv">
                    <button className="hedgeSuggestionBtn" onClick={() => {
                      setTotalInvestmentDetails([]);
                      resetData();
                    }} style={{ backgroundColor: "#efefef" }}>Reset</button>
                    <button className="hedgeSuggestionBtn" onClick={() => fetchHedgeSuggestion('manual', { 'portfolio_df': totalInvestmentDetails })}>Hedge suggestion</button>
                  </div>}
              </div>
            </div>}

            {<div className="hedgeSuggestionSection">
              <div className="MethodsDiv">
                <div className="firstMethodDiv">
                  <span className="methodText">Method-I</span>
                  <DataTable className="hedgeTable" value={hedgeMethodFirst} scrollable resizableColumns stripedRows sortMode="multiple" scrollHeight="200px">
                    <Column field="strike_price" header="Strike price" style={{ minWidth: '50px' }} sortable></Column>
                    <Column field="option_type" header="Option type" style={{ minWidth: '100px' }}  ></Column>
                    <Column field="expiry_date" header="Expiry date" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_n50" header="Lots_(N50)" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_eq" header="Lots_(Eq.Wt.)" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_fs" header="Lots_(Fs.Wt.)" style={{ minWidth: '100px' }}> </Column>
                  </DataTable>
                  {hedgeMethodFirst.length > 0 && <span className="methodText">Investment required :&nbsp; ₹{hedgeMethodFirst[0]['investment_amount']} </span>}
                </div>
                <div className="secondMethodDiv">
                  <span className="methodText">Method-II</span>
                  <DataTable className="hedgeTable" value={hedgeMethodSecond} scrollable resizableColumns stripedRows sortMode="multiple" scrollHeight="200px">
                    <Column field="strike_price" header="Strike price" style={{ minWidth: '100px' }} sortable></Column>
                    <Column field="option_type" header="Option type" style={{ minWidth: '100px' }}  ></Column>
                    <Column field="expiry_date" header="Expiry date" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_n50" header="Lots_(N50)" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_eq" header="Lots_(Eq.Wt.)" style={{ minWidth: '100px' }}> </Column>
                    <Column field="lots_fs" header="Lots_(Fs.Wt.)" style={{ minWidth: '100px' }}> </Column>
                  </DataTable>
                  {hedgeMethodSecond.length > 0 && <span className="methodText">Investment required :&nbsp;₹{hedgeMethodSecond[0]['investment_amount']}</span>}
                </div>
               
              </div>
               <div>
               <span className="returnChartHeader">Hedge PayOff Chart   
                <Tooltip title='This hedge payoff graph shows the potential profit or loss of a hedged position at expiry. It visualizes how the hedge reduces downside risk and limits gains, helping you understand the overall risk-reward profile.'><div><FiInfo /></div>
                </Tooltip></span>
                <ReactApexChart
                    id="mtmApexChart"
                    options={data2.options}
                    series={data2.series}
                    type="area"
                    height="100%"
                  />
               </div>
               
            </div>}
          </div>
        </div>

        <div className="portfolio_return_section">
          <div className="portfolio_return_inner">
            <div style={{ width: '66%' }} className="returnFirstdiv">
              <span className="tableHeaderPortfolio">Check Your Return
                <Tooltip title='Feedsense AI uses data sourced from the Association of Mutual Funds in India (AMFI) website, which is intended for informational purposes only and should not be construed as a guarantee of future performance.'>
                  <span>&nbsp;<FiInfo className='MutualFundInfo' /></span>
                </Tooltip>
              </span>
              <div className='portfolio_return_inner_header'>
                <div style={{display:'flex', gap:'1rem', justifyContent:'space-between'}}>
                  <div style={{display:'flex', gap:'1rem'}}>
                <div className="alignSame">
                  <span><b>Date</b></span>
                  <CustomDateRange backStartDate={startReturnCalcDate} setBackStartDate={setStartReturnCalcDate} backEndDate={endReturnCalcDate} setBackEndDate={setEndReturnCalcDate} />
                </div>

                {/* Amount dropdown */}
                <div className="alignSame">
                  <span><b>Amount</b></span>
                  <Select
                    style={{ width: 120, borderRadius: '5px' }}
                    value={selectedAmountReturnCalc.value}
                    onChange={handleReturnAmountChange}
                    showSearch // Allows manual input
                    filterOption={true} // Disables default filtering
                    onSearch={handleCustomChange} // Captures user input
                  >
                    {displayAmount.map((item: any) => (
                      <Select.Option key={item.value} value={item.value}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                </div>
                <div className="amountStaus">
                <div className="amountStatusInDiv">
                  <span style={{ fontWeight: '500' }}>MF Investment : <span style={{ color: 'green' }}><FaIndianRupeeSign />{numberWithCommas(investment)}</span></span>
                  <div style={{ borderRight: '1px solid gray' }}></div>
                  <span style={{ fontWeight: '500' }}>Net PL : <span style={{ color: (usedAmount?.usedAmount >= 0) ? 'green' : 'red' }}><FaIndianRupeeSign />{numberWithCommas(usedAmount?.usedAmount)}<span style={{ fontWeight: 'bold' }}>({usedAmount?.usedAmountReturn}%)</span></span></span>
                </div>
              </div>
                </div>
                <div style={{display:'flex', gap:'1rem'}}>
                {/* Mutual Fund dropdown */}
                <div className="alignSame MFButton">
                  <span><b>Compare with MF</b></span>
                  <BT onClick={(e) => setSelectedMutualFund(['ALL'])} className={`${selectedMutualFund?.includes('ALL') ? 'ALLBTN' : ''}`}>ALL</BT>
                  <BT onClick={(e) => setSelectedMutualFund(['BEST 3 MF'])} className={`${selectedMutualFund?.includes('BEST 3 MF') ? 'ALLBTN' : ''}`}>BEST 3 MF</BT>
                  <MultiSelect
                    value={selectedMutualFund?.includes('ALL') || selectedMutualFund?.includes('BEST 3 MF') ? [] : selectedMutualFund} // Ensure this is an array of selected values
                    onChange={handleMutualFundChange}
                    options={displayMutualFund}
                    optionLabel="name"  // Show the 'name' field
                    optionValue="value" // Ensure 'value' is used for selection
                    placeholder="Select Mutual Funds"
                    maxSelectedLabels={3}
                    className="w-full"
                    style={{
                      minWidth: "200px", // Ensures it doesn't get too small
                      width: "auto", // Allows it to expand based on content
                      maxWidth: "100%", // Prevents it from overflowing
                      height: "37px",
                      lineHeight: "0.7rem",
                      fontSize: "0.9rem",
                    }}
                    // style={{ height: '37px', lineHeight: '0.7rem', fontSize: '0.9rem' }}
                    filter // Enables search functionality
                    display="chip"
                  />
                </div>

                {/* SUBMIT BUTTON */}
                <div className="alignSame submitBT">
                  {loadingCalc ? <Spin size="small" style={{ width: '4rem' }} /> : <BT onClick={handleReturnCalcSubmit}>Submit</BT>}
                </div>

                </div>
              </div>
              <div style={{ display: 'flex', justifyContent: 'end', color: '#2ca32c', fontSize: '1.5rem', cursor: 'pointer' }}><Tooltip title='Preview and Download'><FaFileExcel onClick={()=>setShowModal(true)} /></Tooltip></div>
              <div className="returnStatus">
                <table className="returnTable">
                  <tr className="pf_avg_return_tbl_head1" style={{ height: '3.2rem', fontWeight: 'bold' }}>
                    <th style={{padding: '0 1.1rem'}}>Feedsense Portfolio</th>
                    <th>Return(%)</th>
                  </tr>
                  <tbody className="pf_avg_return_tbl_body">
                    <tr className="pf_avg_return_tbl_body_tr">
                      <td>Feedsense Optimised Portfolio (With Hedge)</td>
                      <td>{((((Number(feedsensePortfolioData?.feedsenseHedgeReturn) + Number(hedgeSum)) / selectedAmountReturnCalc?.value) - 1) * 100)?.toFixed(2)}</td>
                    </tr>
                    <tr className="pf_avg_return_tbl_body_tr">
                      <td>Feedsense Optimised Portfolio</td>
                      <td>{feedsensePortfolioData?.feedsenseOptReturn}</td>
                    </tr>
                    <tr className="pf_avg_return_tbl_body_tr">
                      <td>Feedsense Equal Portfolio</td>
                      <td>{feedsensePortfolioData?.feedsenseEqualReturn}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="returnTable">
                  <DataTable className="hedgeTableMF" value={mutualFundData} scrollable resizableColumns stripedRows sortMode="multiple" scrollHeight="200px">
                    <Column field="s_symbol" header="Mutual Fund" style={{ minWidth: '100px' }} sortable></Column>
                    <Column field="product_multiplier" header="Return(%)" style={{ minWidth: '150px' }} sortable></Column>
                  </DataTable>
                </div>
              </div>
            </div>
            <div style={{ width: '34%', position:'relative', top:'1.5rem' }} className="returnSeconddiv">
              <span className="returnChartHeader">Portfolio Return Chart (%)</span>
              <div style={{height:'94%'}}>
              <ReactApexChart options={calcMFReturnData.options} series={calcMFReturnData.series} type="bar" height='100%' />
              </div>
            </div>
          </div>
        </div>
        <div className="portfolio_section_2">
          <div className="portfolio_critical_matrix_main">
            <div className='comparative_stats_header'>
              <span className="tableHeaderPortfolio">Comparative Statistics</span>

            </div>
            <div className="table_critical_matrix">
              <div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "32%" }}>
                    <p style={{ width: "70%", height: "100%", fontWeight: "bold" }}>Return Comparison  
                      <Tooltip title='This window displays the rolling average and median values of the below assets for the selected calendar period since inception (01 Apr 2019).'> <FiInfo /></Tooltip>
                      </p>
                    <div style={{ width: "30%", display: "flex", justifyContent: "space-evenly" }}>
                      <button className="portfolio_yr_btn" onClick={() => { setAvgMedianDuration('90') }} id={avgMedianDuration === '90' ? 'crmButtonColour' : ''}>90</button>
                      <button className="portfolio_yr_btn" onClick={() => { setAvgMedianDuration('180') }} id={avgMedianDuration === '180' ? 'crmButtonColour' : ''}>180</button>
                      <button className="portfolio_yr_btn" onClick={() => { setAvgMedianDuration('365') }} id={avgMedianDuration === '365' ? 'crmButtonColour' : ''}>365</button>
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "32%" }}>
                    <p style={{ width: "70%", height: "100%", fontWeight: "bold" }}>Risk And Drawdown</p>
                  </div>

                  <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "32%" }}>
                    <p style={{ width: "70%", height: "100%", fontWeight: "bold" }}>Annual Return Possibilities</p>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <table className="pf_avg_return_tbl">
                    <tr className="pf_avg_return_tbl_head">
                      <th></th>
                      <th>Avg Return(%)</th>
                      <th>Median Return(%)</th>
                    </tr>
                    <tbody className="pf_avg_return_tbl_body">

                      {
                        avgMedianData?.map((item: any) => {
                          return (
                            <>
                              <tr className="pf_avg_return_tbl_body_tr">
                                <td>{item['symbol']}</td>
                                <td>{item['n_median_value']}</td>
                                <td>{item['n_mean_value']}</td>
                              </tr>
                            </>
                          )
                        })
                      }
                    </tbody>
                  </table>

                  <table className="pf_avg_return_tbl_2">
                    <tr className="pf_avg_return_tbl_head1">
                      <th></th>
                      <th>Monthly(%)</th>
                      <th>Half-Yearly(%)</th>
                      <th>Yearly(%)</th>
                    </tr>
                    <tbody className="pf_avg_return_tbl_body">
                      <tr className="pf_avg_return_tbl_body_tr">
                        <td>Max Drawdown</td>
                        <td>{(marketBeatddresponse[1]?.n_drawdown)?.toFixed(2)}</td>
                        <td>{(marketBeatddresponse[0]?.n_drawdown)?.toFixed(2)}</td>
                        <td>{(marketBeatddresponse[2]?.n_drawdown)?.toFixed(2)}</td>
                      </tr>
                      <tr className="pf_avg_return_tbl_body_tr">
                        <td>Market Beat Margin</td>
                        <td>{(marketBeatddresponse[1]?.n_market_beat)?.toFixed(2)}</td>
                        <td>{(marketBeatddresponse[0]?.n_market_beat)?.toFixed(2)}</td>
                        <td>{(marketBeatddresponse[2]?.n_market_beat)?.toFixed(2)}</td>
                      </tr>
                      {/* <tr className="pf_avg_return_tbl_body_tr">
                        <td>Max Loss</td>
                        <td>{marketBeatddresponse[1]?.n_market_beat}</td>
                        <td>{marketBeatddresponse[0]?.n_market_beat}</td>
                        <td>{marketBeatddresponse[2]?.n_market_beat}</td>
                      </tr> */}
                    </tbody>
                  </table>

                  <table className="pf_avg_return_tbl_3">
                    <tr className="pf_avg_return_tbl_head2" style={{ textAlign: "center" }}>
                      <th>Return(%)</th>
                      <th>Frequency</th>
                    </tr>
                    <tbody className="pf_avg_return_tbl_body" style={{ textAlign: "center" }}>
                      {returnPosi?.map((item: any) => {
                        return (
                          <tr className="pf_avg_return_tbl_body_tr">
                            <td>{item?.n_no}</td>
                            <td>{Number(item?.n_posibilities)?.toFixed(2)}</td>
                          </tr>)
                      })}
                    </tbody>
                  </table>

                </div>

              </div>
              <div className='portfolioAn-filter'>
                <span className="tableHeaderPortfolio">Critical Metric</span>
                <CustomDateRange backStartDate={startPortfolioDate} setBackStartDate={setStartPortfolioDate} backEndDate={endPortfolioDate} setBackEndDate={setEndPortfolioDate} />
                <div className='download-options'>
                  <Button type="button" icon="pi pi-file-pdf" rounded onClick={exportPdf} className='button1' />
                  {/* <Button type="button" icon="pi pi-download" rounded onClick={(e: any) => { tradesExports(e, 1) }} className='button1' /> */}
                  <Button type="button" icon="pi pi-download" rounded
                                    onClick={()=>{
                                      setSelectedPreviewTableData(currdata);
                                      setSelectedPreviewTableColumns(portFolioCriticalMetricMappingTableHeader);
                                      setSelectedPreviewTableColumnMapping(portFolioCriticalMetricMapping);
                                      setSelectedFileName("Portfolio Evaluation.csv")
                                      setIsModalOpen(true); }}
                                      className='button1' />
                </div>
              </div>
              <div className="critical_matrix_tbl">

                <CriticalMatrixTable currdata={currdata} />
              </div>
            </div>
          </div>

        </div>
      </div>
      <Modal
        style={{minWidth:'600px'}}
        className="mutualFundModal"
        title={<h5>Mutual Fund Table Preview</h5>}
        centered
        footer={
          <BT onClick={() => downloadMutualExcel(mutualFundData)} style={{borderRadius:'5px',background:'#c3e0f9'}}>Download</BT>
        }
        // loading = {loading}
        open = {showModal}
        onCancel={()=>setShowModal(false)}
      >
      <Table 
        dataSource={tableData} 
        columns={columnsMF} 
        // bordered
        pagination={false}
        scroll={{ y: 200 }}
        size="middle"
        className="custom-scrollbar"
        // scroll={{  y: 47 * 5 }}
        />

      </Modal>


      <Modal
          style={{minWidth:'1250px'}}
          className="mutualFundModal"
          title={<h5>Annual Return Comparison Data</h5>}
          centered
          footer={
          <BT onClick={() => downloadReturnCompAndDrawdownData(returnCompDataExcel)}   style={{borderRadius:'5px',background:'#c3e0f9'}}>Download</BT>
          }
          // loading = {loading}
          open = {returnCompDataShow}
          onCancel={()=>setReturnCompDataShow(false)}
      >
      <Table 
          dataSource={returnCompDataDisplay} 
          columns={columnreturnDrawdown} 
          // bordered
          pagination={false}
          scroll={{ y: 200 }}
          size="middle"
          className="custom-scrollbar"
          // scroll={{  y: 47 * 5 }}
          />

      </Modal>
    </>
  )
}

export default Portfolio;



